var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waste"},[_c('CastomGraphic',{attrs:{"received-data":_vm.receivedData,"graph-type":"line","index-axis":"x","id":"vehicle-house","is-title":false,"aspect-ratio":2,"data-labels":false,"maintain-aspect-ratio":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }